<template>
  <div align="center">
    <v-card
      style="width:800px"
    >
      <v-card-title class="title text--primary text-left">
        {{ $t('terms.title') }}
      </v-card-title>
      <v-card-text class="text--primary text-left">
        <div class="termsText">
          <!-- Se også terms.vue  -->
          <p v-text="$t('terms.p1')" />
          <ul>
            <li v-text="$t('terms.li1')" />
            <li v-text="$t('terms.li2')" />
            <li v-text="$t('terms.li3')" />
            <li v-text="$t('terms.li4')" />
            <li v-text="$t('terms.li5')" />
          </ul>
        </div>
        <div class="termsTextFooter">
          {{ $t('terms.textFooter') }}
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-checkbox
          v-model="userAccepts"
          :label="$t('terms.checkBoxLabel')"
        />
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="!userAccepts"
          @click="acceptTerms"
        >
          {{ $t('terms.buttonAccept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userAccepts: false
    }
  },
  methods: {
    acceptTerms: async function() {
      try {
        const { data } = await this.$api.put('users/acceptterms')

        console.log(data);

        this.$store.dispatch('loadUser');
      } catch (error) {
        console.error(error);
      }
    }
  }
}
</script>

<style>

</style>